module.exports = __webpack_public_path__ + "static/img/zhang.83cd3e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhang.png
// module id = DWIQ
// module chunks = 3